<div class="title-section">
  <div class="title-section__title">
    <p class="title-section__title--text page-padding">
      {{ tabTitle | translate | uppercase }}
    </p>
  </div>
  <div class="title-section__info" [dvTooltip]="iconTooltip | translate">
    <span class="dv-icons">info_filled</span>
  </div>
</div>
